import { render, staticRenderFns } from "./BuyPackageList.vue?vue&type=template&id=e607e0ca&"
import script from "./BuyPackageList.vue?vue&type=script&lang=js&"
export * from "./BuyPackageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports